var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blobWrapper"},[_c('i',{class:_vm.iconSrc}),_c('span',{staticClass:"ml-2 propertyData"},[_vm._v(_vm._s(_vm.propertyValue))]),_c('span',{staticClass:" ml-1 propertyData"},[_vm._v(_vm._s(_vm.propertyUnit))])])}
var staticRenderFns = []

export { render, staticRenderFns }